import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'delivery-engagements-tab-2-part',
	standalone: true,
	templateUrl: './delivery-engagements-tab-2.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./delivery-engagements-tab-2.part.scss`],
})
export class DeliveryEngagementsTab2Part {
}
